// Import the functions you need from the SDKs
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyArf3hP0sflr85thS6kwtOEZ56ueabqjlY",
  authDomain: "propertiesselling-61052.firebaseapp.com",
  projectId: "propertiesselling-61052",
  storageBucket: "propertiesselling-61052.appspot.com",
  messagingSenderId: "145106700787",
  appId: "1:145106700787:web:b88e522aa3f0b7c6db6a86",
  measurementId: "G-M8T9M9L3XQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

// Export the Firebase instances
export { app, analytics, auth, db, storage, googleProvider };